/** Reply form rules (same as the backend) and attachment checks done before uploading. */

export const LIMITS = { subject: 255, body: 5000 };
export const MAX_FILES = 3;
export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const ACCEPT = '.jpg,.jpeg,.png,.pdf';
const ALLOWED_MIME = ['image/jpeg', 'image/png', 'application/pdf'];

/** "Hi Daan,\n\n" (or "Hi,\n\n" without a name). */
export const greeting = (firstName) => `Hi${firstName ? ` ${firstName}` : ''},\n\n`;

/** @returns {{ subject?: string, body?: string }} */
export function validateReply({ subject, body }) {
  const errors = {};
  if (subject.trim().length > LIMITS.subject) errors.subject = `Use at most ${LIMITS.subject} characters.`;
  if (!body.trim()) errors.body = 'Write a message to the customer.';
  else if (body.length > LIMITS.body) errors.body = `Use at most ${LIMITS.body} characters.`;
  return errors;
}

/** True when the body has more than the greeting, or the subject or attachments changed. */
export function hasUnsentText({ subject, body, attachments }, defaults) {
  return body.trim() !== defaults.body.trim() || subject !== defaults.subject || attachments.length > 0;
}

/** Server field errors → { subject, body, attachmentUrls }; anything else → `general`. */
export function mapReplyErrors(fieldErrors = []) {
  const errors = {};
  const general = [];
  for (const { field, message } of fieldErrors) {
    const key = /^attachmentUrls/.test(field ?? '') ? 'attachmentUrls' : field;
    if (['subject', 'body', 'attachmentUrls'].includes(key)) errors[key] = errors[key] ?? message;
    else general.push(message);
  }
  return { errors, general };
}

function isAllowedType(file) {
  if (ALLOWED_MIME.includes(file.type)) return true;
  return !file.type && /\.(jpe?g|png|pdf)$/i.test(file.name);
}

/**
 * Splits picked files into those to upload and rejections (wrong type, > 10 MB, over the
 * 3-file limit), so nothing invalid is ever uploaded.
 * @param {File[]} files
 * @param {number} existing  files already attached
 */
export function checkFiles(files, existing) {
  const accepted = [];
  const rejected = [];
  for (const file of files) {
    if (!isAllowedType(file)) rejected.push(`${file.name}: only JPG, PNG or PDF files can be attached.`);
    else if (file.size > MAX_FILE_BYTES) rejected.push(`${file.name}: files can be at most 10 MB.`);
    else if (existing + accepted.length >= MAX_FILES) rejected.push(`${file.name}: you can attach up to ${MAX_FILES} files.`);
    else accepted.push(file);
  }
  return { accepted, rejected };
}
